import { Trans } from "react-i18next"

import util from "utils/utils"

export default function RequestOpen({ events, ownerChallenge }) {
  return (
    <Trans
      i18nKey="notifications.challengeRequestOpen"
      values={{
        name: util.getEventNames(events),
        challenge: ownerChallenge?.name || "Deleted",
      }}
      components={{ b: <b /> }}
    />
  )
}
